import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

const { InfoPlacement, InfoTheme, InfoLayer } = jest.requireActual('bloko/blocks/drop/Info/Click.js');
export { InfoPlacement, InfoTheme, InfoLayer };

export default mockComponentRenderProp('DropInfoClick', null, {
    withChildren: true,
});
